<template>
  <div class="flex flex-row align-center tags-view-container">
    <tab-scroll
      class="tags-view-wrapper flex flex-row align-center"
    >
      <div
        v-for="tag in visitedViews"
        :key="tag.url"
        class="tags-view-item cursor-pointer flex flex-row align-center"
        :class="isActive(tag)?'active':''"
      >
        <router-link :to="tag.url">
          {{ tag.name }}
        </router-link>
        <span
          v-if="tag.pCode!==''"
          class="el-icon-close"
          @click="handleCloseTag(tag)"
        />
      </div>
    </tab-scroll>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import TabScroll from "@/layout/components/TagsView/TabScroll.vue"

export default {
  name: "TagsView",
  components: { TabScroll },
  computed: {
    ...mapGetters({
      visitedViews: "tagsView/getVisitedViews"
    })
  },
  methods: {
    /**
     * 判断是否为活跃标签
     * @param route
     * @returns {boolean}
     */
    isActive(route) {
      return route.url === this.$route.path
    },
    /**
     * 关闭标签
     * @param route
     */
    handleCloseTag(route) {
      this.$store.dispatch('tagsView/delView', route)
        .then(({ visitedViews }) => {
          const lastView = visitedViews[visitedViews.length - 1]
          if (this.isActive(route)) {
            this.$router.push(lastView.url)
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>

.tags-view-container {
  .tags-view-wrapper {
    .tags-view-item {
      padding: 5px 12px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      font-weight: normal;
      font-size: 14px;
      color: #1D2129;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 8px;

      &:first-child {
        min-width: auto;
      }

      &:last-child {
        margin-right: 0;
      }

      &.active {
        border: 1px solid #165DFF;
        color: #165DFF;
      }
    }
  }
}
</style>
